import React from 'react';

import { AssistantCTACardPersistent } from '../../../../../../elements/AssitantCTACardPersistent/assistantCTACardPersistent';

export const PAThanksCard: React.FC = () => {
	return (
		<AssistantCTACardPersistent
			subtitle="Thank you so much for setting up your payment plan, we really appreciate it. You can easily keep track of all your payment details, schedules, transaction history, reminders and more in the dashboard."
			title="Now what? Now you can relax!"
		/>
	);
};
